import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
import { ChangeEvent, useState, useEffect } from 'react';
import { Input } from 'react-daisyui';

// Own types
import { tInputPassword } from './InputPassword.types';

// Own styles
import './InputPassword.styles.scss';

export default function InputPassword(props: tInputPassword) {
  const { id, name, placeholder, value, onChange, onBlur } = props;
  const [inputValue, setInputValue] = useState<string>(value ? value : '');
  const [showPassword, setShowPassword] = useState<boolean>(false);

  useEffect(() => {
    setInputValue(value ?? '');
  }, [value]);

  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    e.preventDefault();
    onChange(e);
    setInputValue(e.target.value);
  }

  function handleBlur(e: ChangeEvent<HTMLInputElement>) {
    e.preventDefault();
    onBlur(e);
    setInputValue(e.target.value);
  }

  return (
    <div className="InputPassword">
      <Input
        id={id}
        type={showPassword ? 'text' : 'password'}
        name={name}
        placeholder={placeholder}
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
        className="InputPassword__input"
        autoComplete="off"
        size="md"
      />
      <div
        className="InputPassword__iconContainer"
        onClick={() => setShowPassword(!showPassword)}
      >
        {showPassword ? (
          <EyeSlashIcon className="InputPassword__icon" />
        ) : (
          <EyeIcon className="InputPassword__icon" />
        )}
      </div>
    </div>
  );
}
